<template>
  <BModal :model-value="modal" scrollable centered title="Reservation" @update:modelValue="updateModal">
    <template #header>
      <div class="d-flex align-items-center justify-content-between modal-title w-100">
        <h5 class="mb-0 title">Reservation</h5>
        <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span class="bg-success rounded-circle bar-status" style="width: 10px; height: 10px;"></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div>
      </div>
      <BButton
        variant="link"
        class="close"
        @click="updateModal(false)"
      >
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BTabs content-class="mt-3" align="center" justified>
      <BTab title="Reservation" active>
        <BForm>
          <div class="form-group position-relative">
            <BFormInput 
              v-model="searchQuery"
              placeholder="Search guest name"
              autocomplete="off">
              
            </BFormInput>
            <BListGroup v-if="filteredGuestItems.length" class="position-absolute w-100 border rounded-lg" style="z-index: 10">
              <BListGroupItem v-for="guest,index of filteredGuestItems" :key="index" @click="selectGuest(guest)" class="p-2 border-0">{{ guest}}</BListGroupItem>
            </BListGroup>
            <span v-if="searchQuery && filteredGuestItems.length == 0" class="text-muted mt-2">
              Guest not found <router-link to="/guest">Add guest</router-link>
            </span>
          </div>
          <BRow>
            <BCol>
              <div class="form-group">
                <label for="">Check-in Date</label>
                <BFormInput type="date">
                  
                </BFormInput>
              </div>
            </BCol>
            <BCol>
              <div class="form-group">
                <label for="">Check-out Date</label>
                <BFormInput type="date">
          
                </BFormInput>
              </div>
            </BCol>
          </BRow>
          <div class="form-group">

            <BFormSelect v-model="selectedType" :options="types" class="">
              <template #first>
                <BFormSelectOption :value="null" disabled>Select Type Room</BFormSelectOption>
              </template>
              
            </BFormSelect>
          </div>
          <div class="form-group">
            <BFormSelect v-model="selectedNoRoom" :options="no_rooms" class="">
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Room Number
                </BFormSelectOption>
              </template>
              
            </BFormSelect>
          </div>
         
          <div class="form-group">
            <BFormSelect v-model="source.selectedSource" :options="source.sources" class="">
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select Source
                </BFormSelectOption>
              </template>   
            </BFormSelect>
          </div>
          <div class="form-group" v-if="source.selectedSource == 'bo' || source.selectedSource == 'ag'">
            <BFormSelect v-model="source.selectedItemSource" :options="filteredSourceItems" class="">
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  {{ source.selectedSource == 'bo' ? 'Select Platform' : 'Select Agent' }}
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <div class="form-group" v-if="source.selectedSource == 'bo'">
            <BFormInput type="text" placeholder="Booking Confirmation Number"></BFormInput>
          </div>
        </BForm>
      </BTab>
      <BTab title="Extracharge">
        <BForm>
          <BRow v-for="ext,index in extracharges" :key="index">
            <BCol md="5">
                <div class="form-group">
                  <BFormSelect v-model="extracharge.selectedCategory" :options="ext.categories" class="">
                    <template #first>
                      <BFormSelectOption :value="null" disabled>
                        Select Category
                      </BFormSelectOption>
                    </template>
                  </BFormSelect> 
                </div>
            </BCol>
            <BCol md="3">
                <div class="form-group">  
                  <BFormSelect v-model="extracharge.selectedItem" :options="filteredExtrachargeItems" class="">
                    <template #first>
                      <BFormSelectOption :value="null" disabled>
                        Select Item
                      </BFormSelectOption>
                    </template> 
                  </BFormSelect> 
                </div>
            </BCol>
            <BCol md="4">
              <div class="form-group">
                <BInputGroup>
                  <BButton variant="light" class="border"><i class="fas fa-minus" @click="decreaseQuantity(index)"></i></BButton>
                  <BFormInput type="number" v-model="ext.quantity" min="0" class="text-center"></BFormInput>
                  <BButton variant="light" class="border"><i class="fas fa-plus" @click="increaseQuantity(index)"></i></BButton>
                </BInputGroup>
              </div>
            </BCol>
          </BRow>
          <BButton variant="danger" @click="deleteItemExtracharge" class="mr-2"><i class="fas fa-minus"></i></BButton>
          <BButton variant="success" @click="addItemExtracharge"><i class="fas fa-plus"></i></BButton>
            <div class="d-flex justify-content-end align-items-center">
              <p class="m-0">Total Price : <strong>Rp.{{  totalPrice }}</strong></p>
            </div>
        </BForm>
      </BTab>
      <BTab title="Payment">
          <div class="form-group">
            <BFormSelect v-model="selectedPaymentMethod" :options="payment_methods" class="">
              <template #first>
                <BFormSelectOption :value="null" disabled>
                  Select payment method
                </BFormSelectOption>
              </template>
              
            </BFormSelect> 
            <!-- <select name="" id="" class="form-control">
              <option value="">Select payment method</option>
              <option v-for="payment,index of payment_methods" :key="index">{{ payment }}</option>
            </select> -->
          </div>
          <div class="form-group">
            <BFormRadioGroup
              v-model="selectedPaymentType"
              :options="payment_types"
              name="radio-options"
            />
          </div>
          <div class="form-group" v-if="selectedPaymentType == 'DP'">
            <BFormInput type="number" placeholder="Grand Total" disabled>
            </BFormInput>
          </div>
          <BRow v-if="selectedPaymentType == 'DP'">
            <BCol>
              <div class="form-group">
                <label for="">Pre Payment</label>
                <BFormInput type="number" placeholder="Masukkan nominal">
                </BFormInput>
              </div>
            </BCol>
            <BCol>
              <div class="form-group">
                <label for="">Discount(Optional)</label>
                <BFormInput type="text" placeholder="% / nominal ">
                </BFormInput>
              </div>
            </BCol>
          </BRow>
          <div class="form-group" v-if="selectedPaymentType == 'Full payment'">
            <label for="">Discount(Optional)</label>
            <BFormInput type="text" placeholder="% / nominal ">
            </BFormInput>
          </div>
          <div class="form-group" v-if="selectedPaymentType == 'Full payment'">
            <BFormInput type="number" placeholder="Grand Total" disabled>
            </BFormInput>
          </div>
          <div class="form-group">
            <label for="">Payment Date</label>
            <BFormInput type="date">
            </BFormInput>
          </div>
          
          <div class="form-group">
            <BFormTextarea v-model="textEx" placeholder="Remarks(Optional)" rows="3" />
          </div>
      </BTab>
    </BTabs>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
</template>
<script>
import { ref, computed } from "vue";

import { BModal, 
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BForm,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormRadioGroup,
    BInputGroup,
    BListGroup,
    BListGroupItem,
    BButton,
    BFormTextarea } from "bootstrap-vue-next"

export default {
    name: 'ReservationForm',
    components: {
        BModal,
        BFormInput,
        BFormSelect,
        BFormSelectOption,
        BButton,
        BForm,
        BRow,
        BCol,
        BTabs,
        BTab,
        BFormTextarea,
        BInputGroup,
        BListGroup,
        BListGroupItem,
        BFormRadioGroup
    },
    props: {
        modal: Boolean,
    },
    emits: ["update:modal"],

    setup(props, {emit}){

      
      const payment_types = ref([
        { text: 'DP', value: 'DP'},
        { text: 'Full payment', value: 'Full payment'}
      ])
      const selectedPaymentMethod = ref(null)

      const payment_methods = ref([
        
        {text: 'Credit Card'}, 
        {text: 'Cash'}, 
        {text: 'Transfer Bank'}, 
        {text: 'E-Wallet'}
      ])

      const types = ref([
        { text: 'Deluxe'},
        { text: 'Super Deluxe' }, 
        { text: 'Honeymoon' }, 
        { text: 'Studio' }, 
        { text: 'Family'}
      ])
      const selectedType  = ref(null)
      const no_rooms = ref([
        'A1','A2','A3', 'A4','A5'
      ])
      const selectedNoRoom = ref(null)
      const guests = ref([
        'Mr Bones', 'Ms Catherine', 'Mr Brandon', 'Mr Robert', 'Ms Emma'
      ])
      const source = ref(
      {
        selectedSource : null,
        sources: [
          { 
            text: 'Booking Online',
            value: 'bo', 
          },
          {
            text: 'Direct Booking',
            value: 'do', 
          },
          {
            text: 'Agent',
            value: 'ag',
          },
          {
            text: 'Walk-In',
            value: 'wi',
          }
        ],
        selectedItemSource: null,
        items: [
          {
            text: 'Expedia', category: 'bo'
          },
          {
            text: 'Booking.com', category: 'bo'
          },
          {
            text: 'Korasindo', category: 'ag'
          },
          {
            text: 'Travelindo', category: 'ag'
          },
        ],
      })
      


      const searchQuery = ref('')

      const selectedPaymentType = ref('DP')
      const extracharge = ref(
          {
            selectedCategory: null,
            categories: [
              {
                text: 'Resto',
                value: 'resto'
              },
              {
                text: 'Hotel',
                value: 'hotel'
              },
              {
                text: 'Travel',
                value: 'travel'
              },
            ],
            selectedItem: null,
            items: [
              {
                text: "Lunch Buffet 30 Pax", value: "", category: 'resto', price: 50000
              },
              {
                text: "Ayam Rujak", value: "", category: 'resto', price: 50000
              },
              {
                text: "Ayam Soto", value: "", category: 'resto', price: 50000
              },
              {
                text: "Airport Shuttle 9 Person", value: "", category: 'travel', price: 70000
              },
              {
                text: "City Tour in Medan", value: "", category: 'travel', price: 70000
              },
              {
                text: "Day Trip Brastagi", value: "", category: 'travel', price: 70000
              },
              {
                text: "Extra Bed", value: "", category: 'hotel', price: 70000
              },
              {
                text: "Phone Charge", value: "", category: 'hotel', price: 70000
              },
            ],
            quantity: 0,
          }
        )
      const extracharges = ref([
        {
          ...extracharge.value
        }
      ])
      const addItemExtracharge = () => {
        extracharges.value.push({...extracharge.value})
      }
      const deleteItemExtracharge = () => {
        if(extracharges.value.length > 1){
          extracharges.value.pop()
        }
      }
      const increaseQuantity = (index) => {
        extracharges.value[index].quantity++;
      }
      const decreaseQuantity = (index) => {
        if (extracharges.value[index].quantity > 0) {
          extracharges.value[index].quantity--;
        }
      }
      const handleSelectedPaymentType = () => {

      }
      const updateModal = (value) => {
          emit("update:modal", value); // Sync modal state with parent
      };
      const selectGuest = (guest) => {
        searchQuery.value = guest
        filteredGuestItems.value = []
      }
      const totalPrice = computed(() => {
        return extracharges.value.reduce((sum, ext) => {
          const selectedItem = ext.items.find(item => item.value === ext.selectedItem);
          return sum + (selectedItem ? selectedItem.price * ext.quantity : 0);
        }, 0);
      });    
      const filteredExtrachargeItems = computed(() => {
        return extracharge.value.items.filter(item => item.category === extracharge.value.selectedCategory)
      })
      const filteredSourceItems = computed(() => {
        return source.value.items.filter(item => item.category === source.value.selectedSource)
        // return console.log(source.value.items)
      })
      const filteredGuestItems = computed(() => {
        if (!searchQuery.value) return [];
        return guests.value.filter(item =>
          item.toLowerCase().includes(searchQuery.value.toLowerCase())
        );
      });
      return{
          updateModal,
          handleSelectedPaymentType,
          addItemExtracharge,
          deleteItemExtracharge,
          increaseQuantity,
          decreaseQuantity,
          selectGuest,
          selectedPaymentType,
          types,
          no_rooms,
          selectedType,
          selectedNoRoom,
          selectedPaymentMethod,
          source,
          extracharges,
          extracharge,
          payment_types,
          payment_methods,
          guests,
          filteredExtrachargeItems,
          filteredSourceItems,
          filteredGuestItems,
          totalPrice,
          searchQuery,
      }
    }

}
</script>

<style>

@media screen and (max-width: 576px){
  .modal-title .title{
    font-size: 1rem;
  }
  .modal-title .date,
  .modal-title .info-status{
    font-size: 0.675rem;
  }
}
</style>